module.exports = "/images/date.svg";